import {
  IonFab,
  IonFabButton,
  IonFooter,
  IonIcon,
  IonTextarea,
  IonToolbar,
} from '@ionic/react';
import { send as sendIcon } from 'ionicons/icons';
import React, { memo, useContext, useState } from 'react';
import { TranslationContext } from '../../contexts';

interface Props {
  disabled: boolean;
  sendDisabled: boolean;
  isExpertTyping?: boolean;
  isSendingMessage: boolean;
  onSend: (message: string) => void;
  textareaRef?: React.RefObject<HTMLIonTextareaElement>;
}

const ChatInputComponent: React.FC<Props> = ({
  disabled,
  sendDisabled,
  isExpertTyping,
  isSendingMessage,
  onSend,
  textareaRef,
}) => {
  const { translate } = useContext(TranslationContext);
  const [message, setMessage] = useState<string | null>(null);

  const submit = () => {
    if (message) {
      onSend(message);
      setMessage(null);
    }
  };

  const onChange = (event: CustomEvent) => setMessage(event.detail.value);

  const onKeyDown = (event: React.KeyboardEvent<HTMLIonTextareaElement>) => {
    if (event.key === 'Enter') {
      if (!isExpertTyping && !isSendingMessage) {
        if (event.ctrlKey) {
          // TODO: Insert it at cursor position (can not access selectionStart or something like that)
          event.currentTarget.value += '\r\n';
          return true;
        }
        submit();
      } else {
        alert(translate('chat.alertExpertTyping'));
      }
      event.preventDefault();
    }
  };

  return (
    <IonFooter className="footer">
      <IonToolbar className="footer-section">
        <div className="footer-container">
          <div className="input-container">
            <IonTextarea
              disabled={disabled}
              placeholder={translate('chat.write')}
              onIonInput={onChange}
              onKeyDown={onKeyDown}
              value={message}
              autofocus={true}
              autoGrow={false}
              rows={1}
              ref={textareaRef}
              className="placeholdertext input-message"
              padding-start
            />
          </div>
          <div className="send-section">
            <IonFab className="btn-send-container">
              <IonFabButton
                disabled={sendDisabled}
                onClick={submit}
                className="btn-send"
                data-testid="send-button"
              >
                <IonIcon icon={sendIcon} />
              </IonFabButton>
            </IonFab>
          </div>
        </div>
      </IonToolbar>
    </IonFooter>
  );
};

export const ChatInput = memo(ChatInputComponent);
